import { isEmpty, isNil } from 'ramda';

export const hasEmptyProperties = (obj: object) =>
  Object.entries(obj).every(
    ([key, value]) =>
      Object.hasOwn(obj, key) && (Array.isArray(value) ? isEmpty(value) : isNil(value)),
  );
